// Data item types
export type DataItemType = 'text' | 'image' | 'table' | 'url' | 'other';

export interface DataItem {
  id: string;
  type: DataItemType;
  label: string;
  content: string; // text content or base64 for images
  mimeType?: string;
  tags: string[];
  createdAt: number;
  updatedAt: number;
}

export interface FolderItem {
  id: string;
  name: string;
  parentId: string | null;
  order: number;
  createdAt: number;
}

export interface FolderDataLink {
  id: string;
  folderId: string;
  dataId: string;
  order: number;
}

export interface WidgetPage {
  id: string;
  name: string;
  order: number;
  columns: number;
  rows: number;
  createdAt: number;
  updatedAt: number;
}

export interface WidgetItem {
  id: string;
  pageId: string;
  dataId: string;
  x: number;
  y: number;
  width: number;
  height: number;
  order: number;
}

export interface HistoryItem {
  id: string;
  dataId: string;
  createdAt: number;
}

export interface TagItem {
  id: string;
  name: string;
  usageCount: number;
}

export interface AppSettings {
  key: string;
  value: string;
}

// Clipboard preview state
export type ClipboardContentType = 'text' | 'image' | 'html' | 'markdown' | 'json' | 'url' | 'unsupported' | 'empty';

export interface ClipboardPreview {
  id?: string;
  type: ClipboardContentType;
  content: string; // text, html string, or base64 data URL
  rawBlob?: Blob;
}

// History max items (can be changed via in-app purchase later)
export const HISTORY_MAX_ITEMS = 20;
